import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

function GoogleRedirectConvert() {
	const pasteHandler = function (uri, node, done) {
		if (uri.host.match(/google.*/) && uri.path === '/url' && uri.queryKey && uri.queryKey.url) {
			const newUri = decodeURIComponent(uri.queryKey.url);
			node = $(node);
			// currently need to do both of these due to the editor storage format
			node.attr('href', newUri);
			node.attr('data-mce-href', newUri);
			node.text(newUri);
			done(node);
		} else {
			done();
		}
	};

	window.tinymce.plugins.Autoconvert.autoConvert.addHandler(pasteHandler);
}

export default function () {
	bind('init.rte', GoogleRedirectConvert);
}
